import { Component, OnDestroy, OnInit, Input, ViewChild, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import {  NzModalService } from 'ng-zorro-antd/modal';
import { CreateProduct } from 'src/app/modules/product/components/edit-fund/create-product';
import { ParseDataService } from 'src/app/modules/product/services/parseData.service';
import { ValidateService } from 'src/app/modules/product/services/validate.service';
import { MasterDataProductService } from 'src/app/modules/product/services/master-data-product.service';
import { TranslateService } from '@ngx-translate/core';
import { ProductService } from '../../product.service';
import { DataService } from '../../services/data.service';
import { forkJoin, of, Subscription } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { EventManager } from 'src/app/core';
import { ChangedObject } from 'src/app/shared/util/object-change.util';
import { CheckChangeProductPopupComponent } from '../check-change-product-popup/check-change-product-popup.component';
import { createRequestBody } from 'src/app/shared/util';
import { QueryParams } from 'src/app/shared/model/query.params.model';
import { SIP } from '../../models/sip.model';
import { Program } from '../../models/program.model';
import { Fee } from '../../models/fee.model';
declare let $: any;
@Component({
  selector: 'app-edit-sip',
  templateUrl: './edit-sip.component.html',
  styleUrls: ['./edit-sip.component.scss'],
  providers: [ValidateService, DataService],
})
export class EditSipComponent extends CreateProduct implements OnInit, OnDestroy {
  closedOrderBookShiftDay: any = [];
  id: number;
  sip: SIP = new SIP();
  initialSip: any;
  RELEASE_FEE = 'RELEASE_FEE';
  SELL_FEE = 'SELL_FEE';
  SELL_PENALTY = 'SELL_PENALTY';
  isTest: boolean = true;
  subscriptions: Subscription[] = [];
  funds: any[] = [];
  banks: any[] = [];
  isEnable: boolean = false;
  isFeeFromFirstTransaction: boolean = false;
  isFeeFromFirstTransactionBreakSip: boolean = false;
  isCalling: boolean = false;
  public editForm = this.formBuilder.group({
    fundId: ['', [Validators.required]],
    tradingVSD: ['', [Validators.required]],
    codeVSD: ['', [Validators.required]],
    name: ['', [Validators.required]],
    sipCode: ['', [Validators.required]],
    code: [''],
    minBuy: [0, [Validators.required]],
    minSell: [0, [Validators.required]],
    minHold: [0, [Validators.required]],
    monthInvest: [0, [Validators.required]],
    maxMonthInvest: [0],
    isFixed: ['true', [Validators.required]],
    isTransfer: [true],
    isFixedRegisterAmount : [false],
    lastTransferDay: [0],
    noInvestPeriod: [0, [Validators.required]],
    maxNoncontinuousNoninvestmentCycle: [null],
    bankName: [''],
    bankNumber: [''],
    bankCode: [''],
    bankId: [''],
    branch: [''],
    bankAccountComment: [''],
    agentName: [''],
    additionalNote: [''],
    additionalNoteEn: ['']
  });
  days = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30];
  constructor(
    public formBuilder: FormBuilder,
    public router: Router,
    public route: ActivatedRoute,
    public validateService: ValidateService,
    public productService: ProductService,
    public dataService: DataService,
    translate: TranslateService,
    public masterDataProductService: MasterDataProductService,
    public toastrService: ToastrService,
    private eventManager: EventManager,
    public modalService: NzModalService
  ) {
    super(dataService);
    translate.addLangs(['en_US', 'vi_VN']);
    translate.use('vi_VN');
  }
  ngOnInit() {
    this.sip = new SIP();
    this.initialSip = new SIP();
    this.sip.program.supervisoryBankAccount = {};
    this.initialSip.program.supervisoryBankAccount = {};
    super.ngOnInit('CODE_TRADING_FUND');
    this.subscriptions = [
      this.eventManager.subscribe(this.RELEASE_FEE + '-result', (res) => {
        this.sip.feeBuys = [...(res.content || [])];
      }),
      this.eventManager.subscribe(this.SELL_FEE + '-result', (res) => {
        this.sip.feeSells = [...(res.content || [])];
      }),
      this.eventManager.subscribe(this.SELL_PENALTY + '-result', (res) => {
        this.sip.feePenalty = (res.content || []);
      }),
    ];
    this.getMasterData();
  }
  ngOnDestroy() {
    this.eventManager.destroys(this.subscriptions);
  }
  getMasterData() {
    forkJoin(
      this.getRelationalOperator(),
      this.queryFund(),
      this.getBanks()
    )
      .subscribe((results) => {
        this.complete(results);
      });
  }
  getRelationalOperator() {
    return this.masterDataProductService.getRelationalOperator()
      .pipe(map((res: any) => {
        this.resource.relationalOperators = res.list || [];
        this.resource.relationalOperators.forEach((operator) => {
          switch (operator.name) {
            case '<=':
              operator.reverseOperator = '>=';
              break;
            case '<':
              operator.reverseOperator = '>';
              break;
            case '>=':
              operator.reverseOperator = '<=';
              break;
            case '>':
              operator.reverseOperator = '<';
              break;
          }
        });
        return res;
      }));
  }
  queryFund() {
    const queryParams = new QueryParams();
    queryParams.size = 1000;
    queryParams.searchParams.statusCodes = ['PRODUCT_ACTIVE'];
    queryParams.searchParams.typeCodes = ['TRADING_FUND', 'NEW_FUND'];
    let body: any = createRequestBody(queryParams);
    return this.productService.queryActiveFund(body)
      .pipe(map((res: any) => {
        this.funds = res.body.data.list || [];
        return res;
      }));
  }
  getBanks() {
    const queryParams = new QueryParams();
    queryParams.size = 1000;
    let body: any = createRequestBody(queryParams);
    return this.masterDataProductService.getBanks(body)
      .pipe(map((res: any) => {
        this.banks = res.body.data.list || [];
        return res;
      }));
  }
  complete(array) {
    const params = this.route.snapshot.params;
    this.id = params.id;
    if (this.id) {
      this.getDetail();
    }
    this.getResource();
  }
  getDetail() {
    this.productService
      .findProgram(this.id)
      .subscribe(
        (res: any) => {
          const product = res.body.data;
          const listFee = (product.productProgram.listFee || {});
          listFee.BUYFeeList = (listFee.BUYFeeList || []).map((item, index) => { 
            item.schemeId = (item.schemeId || {}).id;
            return new Fee(item) ;
          });
          listFee.SELLFeeList = (listFee.SELLFeeList || []).map((item, index) => { 
            item.schemeId = (item.schemeId || {}).id;
            return new Fee(item) ;
          });
          listFee.SELL_PENALTYFeeList = (listFee.SELL_PENALTYFeeList || []).map((item, index) => { 
            item.schemeId = (item.schemeId || {}).id;
            return new Fee(item) ;
          });
          this.sip = new SIP(product);
          this.sip.program = new Program(product.productProgram);
          const bank = this.sip.program.supervisoryBankAccount || {};
          this.sip.program.supervisoryBankAccount = {
            name: bank.name || '',
            number: bank.number || '',
            branch: bank.branch || '',
            bankId: (bank.bankId || {}).id,
            bankCode: bank.bankCode || '',
            comment: bank.comment,
            agentName: bank.agentName
          }
          this.sip.feeBuys = (listFee.BUYFeeList || []).map((item) => { return new Fee(item) });
          this.sip.feeSells = (listFee.SELLFeeList || []).map((item) => { return new Fee(item) });
          this.sip.feePenalty = (listFee.SELL_PENALTYFeeList || []).map((item) => { return new Fee(item) });
          this.initialSip = new SIP(this.sip);
          this.updateForm();
        }
      );
  }
  updateForm() {
    this.editForm.patchValue({
      fundId: this.sip.program.product.id,
      tradingVSD: this.sip.program.tradeCode,
      codeVSD: this.sip.program.vsdCode,
      sipCode: this.sip.sipCode,
      name: this.sip.program.name,
      code: this.sip.program.tradeCode,
      minBuy: this.sip.program.buyMinValue,
      minSell: this.sip.program.sellMin,
      minHold: this.sip.program.holdingMin,
      monthInvest: this.sip.minCycleLength,
      maxMonthInvest: this.sip.maxCycleLength,
      isFixed: this.sip.isFixedLastTransferDay ? 'true' : 'false',
      isTransfer: this.sip.program.isTransfer ? true : false,
      isFixedRegisterAmount: this.sip.isFixedRegisterAmount,
      lastTransferDay: this.sip.lastTransferDay || undefined,
      noInvestPeriod: this.sip.maxContinuousNoninvestmentCycle,
      maxNoncontinuousNoninvestmentCycle: this.sip.maxNoncontinuousNoninvestmentCycle,
      bankName: this.sip.program.supervisoryBankAccount.name,
      bankNumber: this.sip.program.supervisoryBankAccount.number,
      bankCode: this.sip.program.supervisoryBankAccount.bankCode,
      bankId: this.sip.program.supervisoryBankAccount.bankId,
      branch: this.sip.program.supervisoryBankAccount.branch,
      additionalNote: this.sip.additionalNote,
      additionalNoteEn: this.sip.additionalNoteEn,
      bankAccountComment: this.sip.program.supervisoryBankAccount.comment,
      agentName: this.sip.program.supervisoryBankAccount.agentName
    });
    this.isEnable = this.sip.isEnable;
    this.isFeeFromFirstTransaction = this.sip.isFeeFromFirstTransaction;
    this.isFeeFromFirstTransactionBreakSip = this.sip.isFeeFromFirstTransactionBreakSip;
  }
  changeEnable() {
    this.isEnable = !this.isEnable;
  }
  createRequestBody() {
    const values = this.editForm.value;
    const bank =
    {
      name: values.bankName || '',
      number: values.bankNumber || '',
      branch: values.branch || '',
      bankId: values.bankId,
      bankCode: values.bankCode,
      comment: values.bankAccountComment,
      agentName: values.agentName
    };
    let isHasBank = false;
    Object.keys(bank).forEach((property) => {
      isHasBank = isHasBank || bank[property] ? true : false;
    });
    const body = {
      id: this.id,
      minCycleLength: values.monthInvest,
      maxCycleLength: values.maxMonthInvest,
      maxContinuousNoninvestmentCycle: values.noInvestPeriod,
      maxNoncontinuousNoninvestmentCycle: values.maxNoncontinuousNoninvestmentCycle,
      lastTransferDay: values.isFixed === 'true' ? values.lastTransferDay : null,
      isFixedLastTransferDay: values.isFixed === 'true' ? true : false,
      isEnable: this.isEnable,
      isFixedRegisterAmount: values.isFixedRegisterAmount,
      isFeeFromFirstTransaction: this.isFeeFromFirstTransaction,
      isFeeFromFirstTransactionBreakSip: this.isFeeFromFirstTransactionBreakSip,
      sipCode: values.sipCode,
      additionalNote: values.additionalNote,
      additionalNoteEn: values.additionalNoteEn,
      productProgram: {
        name: values.name,
        tradeCode: values.tradingVSD,
        vsdCode: values.codeVSD,
        buyMinValue: values.minBuy,
        sellMin: values.minSell,
        holdingMin: values.minHold,
        statusCode: 'PROGRAM_ACTIVE',
        schemeCode: 'SIP',
        productId: values.fundId,
        isBuy: true,
        isSell: true,
        isTransfer: values.isTransfer,
        productSupervisoryBankAccounts: isHasBank ? [bank] : [],
        listFee: [...this.sip.feeBuys, ...this.sip.feeSells, ...this.sip.feePenalty].map((fee) => {
          fee.schemeId = (fee.schemeId || {}).id;
          return fee;
        })
      }
    }
    return body;
  }
  clearBank() {
    this.editForm.patchValue({
      bankName: '',
      bankNumber: '',
      bankId: '',
      branch: '',
    });
  }
  disabledButton() {
    let result = this.editForm.invalid;
    const isFixed = this.editForm.get('isFixed').value;
    if ((isFixed === 'true' && !this.editForm.get('lastTransferDay').value)) {
      result = true;
    }
    if (this.sip.feeBuys.some(item => item.fee === undefined || (item.beginValue === 0 && item.endValue === null))
      || this.sip.feeSells.some(item => item.fee === undefined || (item.beginValue === 0 && item.endValue === null)) 
      || this.sip.feePenalty.some(item => item.fee === undefined || (item.beginValue === 0 && item.endValue === null))) {
      result = true;
    }
    return result;
  }
  test() {
    this.isValidated = true;
    this.eventManager.broadcast({ name: this.RELEASE_FEE + '-emit', content: {} });
    this.eventManager.broadcast({ name: this.SELL_PENALTY + '-emit', content: {} });
    this.eventManager.broadcast({ name: this.SELL_FEE + '-emit', content: {} });
    setTimeout(() => {
      const error = $('.error-text');
      if ((error && error.length > 0) || this.disabledButton()) {
        // window.scrollTo(0, 0);
        this.toastrService.error('Có dữ liệu bị lỗi');
        return true;
      }
      this.parsebeforeValidated();
      const properties = this.checkChange();
      const modal = this.modalService.create({
        nzTitle: '',
        nzWidth: '650px',
        nzStyle: { top: '20px' },
        nzClassName: 'check-change-popup',
        nzContent: CheckChangeProductPopupComponent,
        nzData: {
          properties: properties,
        },
        nzOnOk: (() => { this.save() })
      });
    }, 1000)
  }
  checkChange() {
    const values: any = this.editForm.value;
    this.sip.program.name = values.name;
    this.sip.program.tradeCode = values.tradingVSD;
    this.sip.program.vsdCode = values.codeVSD;
    this.sip.program.buyMinValue = values.minBuy;
    this.sip.program.sellMin = values.minSell;
    this.sip.program.holdingMin = values.minHold;
    this.sip.program.supervisoryBankAccount = {
      name: values.bankName || '',
      number: values.bankNumber || '',
      branch: values.branch || '',
      bankId: values.bankId,
      bankCode: values.bankCode,
      comment: values.bankAccountComment,
      agentName: values.agentName
    }
    this.sip.minCycleLength = values.monthInvest;
    this.sip.maxCycleLength = values.maxMonthInvest;
    this.sip.maxContinuousNoninvestmentCycle = values.noInvestPeriod;
    this.sip.lastTransferDay = values.lastTransferDay;
    this.sip.isFixedLastTransferDay = values.isFixed === 'true' ? true : false;
    let changeObject = ChangedObject.parse(new SIP(this.sip), new SIP(this.initialSip));
    let changeObject1 = ChangedObject.parse(this.sip.program, this.initialSip.program);
    let changeObject2 = ChangedObject.parse(this.sip.program.supervisoryBankAccount, this.initialSip.program.supervisoryBankAccount);
    delete changeObject.program;
    const properties = Object.keys(changeObject).map((key) => {
      let initValue = this.initialSip[key];
      let changeValue = changeObject[key];
      switch (key) {
        case 'feeBuys':
          initValue = 'Có thay đổi';
          changeValue = 'Có thay đổi';
          break;
        case 'feeSells':
          initValue = 'Có thay đổi';
          changeValue = 'Có thay đổi';
          break;
        case 'feePenalty':
            initValue = 'Có thay đổi';
            changeValue = 'Có thay đổi';
            break;
      }
      return {
        key,
        initValue,
        changeValue
      }
    });
    Object.keys(changeObject1).map((key) => {
      let initValue = this.initialSip.program[key];
      let changeValue = changeObject1[key];
      if (key !== 'supervisoryBankAccount') {
        properties.push({
          key,
          initValue,
          changeValue
        })
      }
    });
    Object.keys(changeObject2).map((key) => {
      let initValue = this.initialSip.program.supervisoryBankAccount[key];
      let changeValue = changeObject2[key];
      properties.push({
        key: 'bank-' + key,
        initValue,
        changeValue
      })
    });
    return properties;
  }
  save() {
    if (!this.validate()) {
      return;
    }
    this.isTest = false;

    this.executeRequest();
  }
  hasError() {
    const error = $('.error-text');
    if (error && error.length > 0) {
      return true;
    } else return false;
  }
  changeTab(tab) {
    this.tab = tab;
  }
  changePrice() {
    // this.product.nav = this.product.issuePrice;
  }
  executeRequest() {
    this.isCalling = true;
    forkJoin(
      this.callUpdate(),
    )
      .subscribe((results) => {
        this.isCalling = false;
        if (!this.sip.program.id) {
          this.router.navigate(['products/sip']);
        }
        this.completeUpdate(results);
      });
  }
  completeUpdate(array) {
    this.toastrService.success('Save Product Successfully!');
  }
  callUpdate() {
    const body: any = this.createRequestBody();
    const method = this.sip.program.id ? 'updateProgram' : 'createProgram';
    return this.productService[method](body)
      .pipe(map((res: any) => {
        return res;
      }));
  }
}
